module.exports = {
          srcSet: __webpack_public_path__ + "dc801c28.jpg"+" 700w"+","+__webpack_public_path__ + "2ff5d986.jpg"+" 1400w"+","+__webpack_public_path__ + "33fb7c44.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "dc801c28.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "2ff5d986.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "33fb7c44.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "dc801c28.jpg",
          toString:function(){return __webpack_public_path__ + "dc801c28.jpg"},
          
          width: 700,
          height: 467
        }